document.addEventListener("DOMContentLoaded", function () {
  const departmentSelectors = document.getElementsByClassName('js-contact-department--selector');
  const departmentTargets = document.getElementsByClassName('js-contact-department--target');
  if (departmentSelectors && departmentTargets) {
    const selectors = Array.from(departmentSelectors);
    const targets = Array.from(departmentTargets);
    selectors.forEach(selector => {
      selector.addEventListener('change', (e) => {
        const target = targets.filter(x => x.dataset.contactDepartmentId == e.target.dataset.contactDepartmentId)[0];
        const url = new URL(target.href);
        url.searchParams.set("countryEmail", e.target.value);
        target.href = url.toString();
      });
    });
  }
});